import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const UpdateDiagnosticReportDocument = gql`
  mutation UpdateDiagnosticReport($diagnosticReport: DiagnosticReportIn!) {
    updateDiagnosticReport(diagnosticReport: $diagnosticReport) {
      code {
        coding {
          system
          code
        }
      }
      effectiveDateTime
      id
      status
      result {
        reference
      }
    }
  }
`;
export type UpdateDiagnosticReportMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateDiagnosticReportMutationResponse,
    UpdateDiagnosticReportMutationVariables
  >;

/**
 * __useUpdateDiagnosticReportMutation__
 *
 * To run a mutation, you first call `useUpdateDiagnosticReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiagnosticReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiagnosticReportMutation, { data, loading, error }] = useUpdateDiagnosticReportMutation({
 *   variables: {
 *      diagnosticReport: // value for 'diagnosticReport'
 *   },
 * });
 */
export function useUpdateDiagnosticReportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateDiagnosticReportMutationResponse,
    UpdateDiagnosticReportMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateDiagnosticReportMutationResponse,
    UpdateDiagnosticReportMutationVariables
  >(UpdateDiagnosticReportDocument, baseOptions);
}
export type UpdateDiagnosticReportMutationHookResult = ReturnType<
  typeof useUpdateDiagnosticReportMutation
>;
export type UpdateDiagnosticReportMutationResult =
  ApolloReactCommon.MutationResult<UpdateDiagnosticReportMutationResponse>;
export type UpdateDiagnosticReportMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateDiagnosticReportMutationResponse,
    UpdateDiagnosticReportMutationVariables
  >;
export type UpdateDiagnosticReportMutationVariables = Types.Exact<{
  diagnosticReport: Types.DiagnosticReportIn;
}>;

export type UpdateDiagnosticReportMutationResponse = {
  __typename: 'Mutation';
  updateDiagnosticReport: {
    __typename: 'DiagnosticReport';
    effectiveDateTime?: Types.Maybe<string>;
    id?: Types.Maybe<string>;
    status: Types.DiagnosticReportStatus;
    code: {
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    };
    result?: Types.Maybe<
      Array<{ __typename: 'Reference'; reference?: Types.Maybe<string> }>
    >;
  };
};
